<template>
    <div class="table">
        <div class="container">
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-select v-model="form.deptId" placeholder="请选择学校" @change="getData">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <!-- <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-select v-model="form.roleType" clearable placeholder="展示对象">
                        <el-option
                            v-for="item in roleTypes"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.moduleTitle" placeholder="功能名称"></el-input>
                </div>
            </div>  -->
            <!-- &nbsp; -->
            <!-- <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button> -->
            
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="roleId"
                v-loading="loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                element-loading-text = "数据正在加载中..."
                border
                default-expand-all>
                <!-- <el-table-column type="selection" width="55" :selectable="selectable"></el-table-column> -->
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="roleType" label="展示对象" width="90px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.roleType == 1">
                            家长
                        </div>
                        <div v-else-if="scope.row.roleType == 2">
                            教职
                        </div>
                        <div v-else>
                            家长,教职
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="功能LOGO"  :show-overflow-tooltip="true" width="90px" >
                    <template slot-scope="scope">
                        <div v-if="scope.row.moduleIcon != null && scope.row.moduleIcon != ''">
                            <!-- <div style="position:absolute;text-align:center;top:26px;font-size:12px;font-weight:bold;color:#FFFF00;">审核中</div> -->
                            <el-popover
                                placement="right"
                                title=""
                                trigger="hover">
                                <img :src="scope.row.moduleIcon" lazy="loading"
                                    style="max-height:250px; max-width:330px"/>
                                <img slot="reference" :src="scope.row.moduleIcon"  lazy="loading" :alt="scope.row.moduleIcon" style="max-height: 50px;max-width: 130px">
                            </el-popover>
                        </div>
                        <div v-else>
                            未上传
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="moduleTitle" label="功能名称" :show-overflow-tooltip="true" width="90px"></el-table-column>
                <el-table-column prop="moduleTitleByname" label="功能别名" :show-overflow-tooltip="true" width="90px"></el-table-column>
                <el-table-column prop="commonName" label="绑定五育指标" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.commonName != null">
                            {{scope.row.commonName}}
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="moduleStatus" label="功能状态" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.moduleStatus == 0">
                            <span style="color:red">禁用</span>
                        </div>
                        <div v-else-if="scope.row.moduleStatus == 1">
                            启用
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="评价人" :show-overflow-tooltip="true" width="150">
                    <template slot-scope="scope">
                        <div v-if="scope.row.showUserRoster == '' || scope.row.showUserRoster == null">
                            全部人员
                        </div>
                        <div v-else>
                            {{scope.row.showUserRosterName}}
                        </div>
                    </template>
                </el-table-column>
                 <!-- <el-table-column prop="" label="无权限者" :show-overflow-tooltip="true" width="150">
                    <template slot-scope="scope">
                        <div v-if="scope.row.notshowUserRoster == '' || scope.row.notshowUserRoster == null">
                            无
                        </div>
                        <div v-else>
                            {{scope.row.commonName2}}
                        </div>
                    </template>
                </el-table-column> -->
                <el-table-column fixed="right" label="操作" width="100px" style="text-align:'left'">
                    <template slot-scope="scope">
                        <el-button @click.native.prevent="findUser(scope.row)"
                            type="text"
                            size="small" style="color: #387EE8;">
                            设置评价人
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
        <!-- 人员弹出框 -->
        <div v-if="transferVisible">
            <userTransfer ref="userTransfer"></userTransfer>
        </div>
    </div>
</template>

<script>
    import http from '../../../../common/http'; 
    import userTransfer from '../../sys/user/UserTransfer.vue';

    export default {
        name:"ModuleConfig",
        data(){
            return{
                loading:false,
                transferVisible:false,
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    id:"",
                    deptId:"",
                    moduleStatus:"",
                    moduleTitle:"",
                    roleType:"",
                    evaluateId:""
                },
                data:[],
                depts:[],
                roleTypes:[{
                    value: 0,
                    label: '全部'
                },{
                    value: 1,
                    label: '家长'
                },{
                    value: 2,
                    label: '教职'
                }]
            }
        },
        components: {
            userTransfer
        },
        created:function () {
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                this.loading=true;
                let url  = this.moduleConfigListUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    deptId:this.form.deptId,
                    moduleTitles:'班级评价,教职评价',
                    roleType:(this.form.roleType=='0'?'':this.form.roleType)
                };
                // console.log(data);
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.list;
                        this.common.total=res.data.total;   
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            selectable(row){
                if(row.id == 1){
                    return false;
                }
                else{
                    return true;
                }
            },
           handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            findUser(row){
                this.form.id=row.id;
                this.transferVisible=true;
                this.$nextTick(() => {
                    if(this.$util.isNotEmpty(row.showUserRoster)){
                        let val=row.showUserRoster.split(',');
                        this.$refs['userTransfer'].init(2,val,2,this.form.deptId);
                    }else{
                        this.$refs['userTransfer'].init(2,null,2,this.form.deptId);
                    }
                })
            },
            setUser(key,label){
                let data = {
                    id:this.form.id,
                    showUserRoster:key
                };
                let url  = this.moduleConfigUpdateShowUserRosterUrl;
                this.loading=true;
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            }  
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/evaluate/moduleConfig.vue